import { useNavigate } from "react-router-dom"
import { Button } from "@/components/ui/button"
import SEO from '@/components/SEO';

export default function NotFound() {
  const navigate = useNavigate()

  return (
    <>
      <SEO 
        title="Page Not Found" 
        description="The page you're looking for doesn't exist or has been moved."
        noindex={true}
      />
      <div className="flex-1">
        <div className="min-h-screen flex flex-col items-center justify-center bg-gray-50">
          <h1 className="text-4xl font-bold mb-4">404 - Page Not Found</h1>
          <p className="text-gray-600 mb-8">The page you're looking for doesn't exist.</p>
          <p className="text-green-600 mb-8">We are working hard to deliver a great product for you all, do reach us at hello@causeconnect.ai, if you have any feedback for us.</p>
          <Button onClick={() => navigate("/")} variant="default">
            Return Home
          </Button>
        </div>
      </div>
    </>
  )
}